export default __webpack_public_path__ + "static/docs-623fc9830627881c23b5f60518028959.png";